export default function Go_Comparison () {
  return (
    <div>
      <h1>Go_Comparison </h1>
      <p>Comparison</p>
    </div>
  );
}